export const ItemImageBorder = () => {
  return (
    <svg
      width="127"
      height="127"
      viewBox="0 0 127 127"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="1.21875"
        y="1.4082"
        width="124.5"
        height="124.5"
        rx="62.25"
        stroke="#4A085A"
        strokeWidth="1.5"
        strokeDasharray="2 9"
      />
    </svg>
  );
};

export const StarIcon = () => {
  return (
    <svg width="16px" height="15px" viewBox="0 0 16 15" version="1.1">
      <title>Path</title>
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g
          transform="translate(-70.000000, -221.000000)"
          fill="#464646"
          fillRule="nonzero"
        >
          <g id="doublepoints-popup" transform="translate(-1.000000, 0.000000)">
            <g id="icons" transform="translate(65.000000, 221.000000)">
              <path
                d="M14.4621755,0.249035648 L12.9662066,3.538854 L9.00482698,1.31827231 L8.978477,1.30459247 C8.62650724,1.13620416 8.25382385,1.52342486 8.4311776,1.89371726 L10.3732018,5.94842962 L6.75239512,7.98756272 L6.72365536,8.00515304 C6.40067939,8.21959726 6.50757345,8.74931518 6.90005974,8.80025469 L10.7649146,9.30177017 L9.50426289,13.3408236 L9.49589581,13.3708986 C9.40081332,13.7599448 9.83412607,14.0697152 10.1528589,13.8226043 L13.5479168,11.1901687 L16.1559918,14.824223 L16.1762395,14.8504833 C16.426064,15.1520617 16.915751,14.9684071 16.9100751,14.5585494 L16.8511103,10.3132881 L21.115411,10.29765 L21.147371,10.2964014 C21.5350522,10.2672795 21.6804464,9.73763727 21.3490434,9.50405301 L17.8245333,7.01988295 L20.759343,3.37066827 L20.7774487,3.34669002 C21.0172891,3.00771522 20.6882867,2.53695634 20.2960092,2.68384367 L16.2781885,4.18815385 L15.2439223,0.318285842 C15.1402266,-0.0696742192 14.6277281,-0.115073342 14.4621755,0.249035648 Z M14.7383303,1.67673153 L15.5924337,4.8718923 L15.6019641,4.90304004 C15.6793355,5.12679068 15.9185616,5.24640814 16.1377385,5.16433786 L19.1266854,4.04504729 L16.8859523,6.83149666 L16.865558,6.85897282 C16.7313698,7.05526969 16.7767185,7.33134307 16.9721239,7.46907153 L19.76008,9.43401887 L16.4252602,9.4463996 L16.3937973,9.44772491 C16.1757222,9.46535442 16.0051067,9.65626358 16.0083014,9.88695234 L16.0545021,13.2288399 L13.9689201,10.3226963 L13.9472823,10.2949622 C13.8046565,10.1266251 13.5589097,10.0976687 13.3828245,10.2341861 L10.7059066,12.3093966 L11.7171344,9.06991566 L11.7256683,9.0387569 C11.7845942,8.78926748 11.6211147,8.53759006 11.3709367,8.50512027 L8.29641259,8.10610296 L11.127307,6.512142 L11.1560974,6.49436901 C11.3326182,6.37532699 11.3977272,6.13598847 11.3024644,5.9370917 L9.76784654,2.73320101 L12.9573092,4.52120568 C13.1685306,4.63961214 13.432235,4.54973208 13.5346813,4.32441622 L14.7383303,1.67673153 Z"
                id="Stroke-27"
              ></path>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
};

export const SparkleIcon = () => {
  return (
    <svg width="24px" height="23px" viewBox="0 0 24 23" version="1.1">
      <title>Group 50</title>
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g
          transform="translate(-322.000000, -371.000000)"
          fill="#464646"
          fillRule="nonzero"
        >
          <g id="doublepoints-popup" transform="translate(-1.000000, 0.000000)">
            <g id="icons" transform="translate(65.000000, 221.000000)">
              <g id="Group-50" transform="translate(258.533179, 150.000000)">
                <path
                  d="M11.2178445,17.5549825 C11.4649285,17.5670503 11.6551907,17.7720236 11.642807,18.0128033 L11.407635,22.5853231 C11.3952513,22.8261028 11.1849111,23.0115105 10.9378271,22.9994428 C10.6907431,22.9873751 10.5004808,22.7824017 10.5128645,22.5416221 L10.7480366,17.9691022 C10.7598574,17.739267 10.9520476,17.5598845 11.1843941,17.5545476 L11.2178445,17.5549825 Z"
                  id="Stroke-11"
                ></path>
                <path
                  d="M12.0909567,0.000434922233 C12.3380407,0.0125026391 12.5283029,0.217475957 12.5159192,0.458255643 L12.2807472,5.03077551 C12.2683635,5.27155519 12.0580234,5.45696288 11.8109393,5.44489516 C11.5638553,5.43282744 11.3735931,5.22785412 11.3859767,4.98707444 L11.6211488,0.414554574 C11.6329696,0.18471942 11.8251598,0.00533685423 12.0575063,0 L12.0909567,0.000434922233 Z"
                  id="Stroke-13"
                ></path>
                <path
                  d="M0.458210796,10.5139562 L5.03113602,10.7462489 C5.27194277,10.7584813 5.45746448,10.9681535 5.44551035,11.2145649 C5.43355622,11.4609764 5.22865304,11.650816 4.98784629,11.6385836 L0.414921062,11.4062909 C0.174114312,11.3940586 -0.011407392,11.1843863 0.000546737852,10.9379749 C0.0119574981,10.702764 0.199175139,10.5190989 0.425610803,10.513527 L0.458210796,10.5139562 Z"
                  id="Stroke-15"
                ></path>
                <path
                  d="M18.0121537,11.386991 L22.5850789,11.6192837 C22.8258857,11.6315161 23.0114074,11.8411883 22.9994533,12.0875997 C22.9874991,12.3340112 22.782596,12.5238508 22.5417892,12.5116185 L17.968864,12.2793257 C17.7280572,12.2670934 17.5425355,12.0574212 17.5544897,11.8110097 C17.5659004,11.5757988 17.7531181,11.3921337 17.9795537,11.3865618 L18.0121537,11.386991 Z"
                  id="Stroke-17"
                ></path>
                <path
                  d="M15.5758947,16.002 C15.7546513,15.8402217 16.030721,15.8539725 16.1925137,16.0327133 L19.252772,19.4135406 C19.4145646,19.5922814 19.4008126,19.8683267 19.222056,20.030105 C19.0432993,20.1918833 18.7672296,20.1781325 18.605437,19.9993917 L15.5451786,16.6185643 C15.383386,16.4398235 15.397138,16.1637783 15.5758947,16.002 Z"
                  id="Stroke-19"
                ></path>
                <path
                  d="M3.77796586,2.96977273 C3.9567225,2.80799443 4.23279223,2.82174525 4.39458487,3.00048603 L7.45484318,6.38131337 C7.61663582,6.56005416 7.60288379,6.83609942 7.42412716,6.99787771 C7.24537052,7.15965601 6.96930079,7.1459052 6.80750815,6.96716441 L3.74724984,3.58633707 C3.5854572,3.40759629 3.59920923,3.13155103 3.77796586,2.96977273 Z"
                  id="Stroke-21"
                ></path>
                <path
                  d="M6.37972546,15.5437606 C6.55842469,15.381919 6.83449928,15.3955718 6.99635532,15.5742552 C7.15821137,15.7529386 7.14455727,16.0289887 6.96585805,16.1908304 L3.58473099,19.2530001 C3.40603177,19.4148417 3.12995718,19.4011889 2.96810113,19.2225055 C2.80624509,19.0438221 2.81989918,18.767772 2.99859841,18.6059303 L6.37972546,15.5437606 Z"
                  id="Stroke-23"
                ></path>
                <path
                  d="M19.4154056,3.74677372 C19.5941623,3.58499542 19.870232,3.59874624 20.0320246,3.77748702 C20.1938173,3.95622781 20.1800652,4.23227307 20.0013086,4.39405137 L16.6201816,7.45403841 C16.4414249,7.61581671 16.1653552,7.60206589 16.0035626,7.4233251 C15.8417699,7.24458432 15.855522,6.96853906 16.0342786,6.80676076 L19.4154056,3.74677372 Z"
                  id="Stroke-25"
                ></path>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
};

export const Lineicon = () => {
  return (
    <svg width="41px" height="44px" viewBox="0 0 41 44" version="1.1">
      <title>Group 11</title>
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g transform="translate(-284.000000, -243.000000)" stroke="#4A085A">
          <g id="doublepoints-popup" transform="translate(-1.000000, 0.000000)">
            <g id="icons" transform="translate(65.000000, 221.000000)">
              <g id="Group-11" transform="translate(220.648438, 23.341585)">
                <path
                  d="M0,6.29904006 C18.40625,8.85177444 34.5253906,23.7189619 39.2363281,42.4943526"
                  id="Path-12"
                ></path>
                <path
                  d="M0.785338096,1.29867493 C6.40207283,2.07765119 11.7333032,4.39386468 16.3132504,7.81804074"
                  id="Path-12-Copy"
                  transform="translate(8.549294, 4.558358) rotate(-10.000000) translate(-8.549294, -4.558358) "
                ></path>
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
};
